import { Mail, Phone, MapPin, Instagram, Linkedin, Facebook, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import logoVerde from "@/assets/logo-verde.webp";

const navLinks = [
  { label: "O que está incluso", href: "#incluso", external: false },
  { label: "Como funciona", href: "#como-funciona", external: false },
  { label: "Benefícios", href: "#beneficios", external: false },
  { label: "Depoimentos", href: "#depoimentos", external: false },
  { label: "Comparativo", href: "#comparativo", external: false },
  { label: "FAQ", href: "#faq", external: false },
  { label: "Blog", href: "/blog", external: false, isRoute: true },
];

const socialLinks = [
  { icon: Instagram, href: "https://instagram.com/aceena.br", label: "Instagram" },
  { icon: Linkedin, href: "https://linkedin.com/company/aceena", label: "LinkedIn" },
  { icon: Facebook, href: "https://facebook.com/aceena.br", label: "Facebook" },
  { icon: Youtube, href: "https://www.youtube.com/@aceena_carroporassinatura", label: "YouTube" },
];

export const Footer = () => {
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-foreground text-background py-16">
      <div className="container">
        {/* Social Media Section */}
        <div className="text-center mb-12 pb-12 border-b border-background/10">
          <p className="text-lg font-semibold text-background mb-2">
            SIGA NOSSAS REDES SOCIAIS
          </p>
          <p className="text-background/60 mb-6">
            E fique por dentro de todas as novidades!
          </p>
          <div className="flex items-center justify-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-background/10 flex items-center justify-center text-background/70 hover:bg-aceena-green hover:text-primary transition-all duration-300"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img
              src={logoVerde}
              alt="Aceena"
              className="h-10 w-auto mb-4"
            />
            <p className="text-background/70 max-w-sm leading-relaxed">
              Aceena — consultoria técnica em carro por assinatura, com mais de
              30 anos de experiência no setor automotivo.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-semibold text-background mb-4">Navegação</p>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-background/70 hover:text-aceena-green transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (link as any).isRoute ? (
                    <Link
                      to={link.href}
                      className="text-background/70 hover:text-aceena-green transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-background/70 hover:text-aceena-green transition-colors"
                    >
                      {link.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-background mb-4">Contato</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-background/70">
                <Phone className="w-4 h-4 text-aceena-green" />
                <a
                  href="https://wa.me/5511964774179"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-aceena-green transition-colors"
                >
                  +55 11 96477-4179
                </a>
              </li>
              <li className="flex items-center gap-3 text-background/70">
                <Mail className="w-4 h-4 text-aceena-green" />
                <a
                  href="mailto:contato@aceena.com.br"
                  className="hover:text-aceena-green transition-colors"
                >
                  contato@aceena.com.br
                </a>
              </li>
              <li className="flex items-center gap-3 text-background/70">
                <MapPin className="w-4 h-4 text-aceena-green" />
                <span>Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-background/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background/50">
          <p>© {new Date().getFullYear()} Aceena. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <Link 
              to="/politica-de-privacidade"
              className="hover:text-aceena-green transition-colors"
            >
              Política de Privacidade
            </Link>
            <Link 
              to="/termos-de-uso"
              className="hover:text-aceena-green transition-colors"
            >
              Termos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
